export const PUBLIC_URLS = {
  blog: 'https://www.apptonomy.ai/blog',
  cookiePolicy: '/cookie-policy',
  privacyPolicy: '/privacy',
  termsOfService: '/terms',
} as const;
